export enum BackOffice {
    TF = "TF",
    DEMO = "DEMO",
    GE = "GE",
    GE_PERSHING = "GE_PERSHING",
    PULSE = "PULSE",
    MORGANS = "MORGANS",
    SHAW = "SHAW",
    PHILLIP = "PHILLIP",
    AUSIEX = "AUSIEX",
    GAME = "GAME",
    NEWCASTLE = "NEWCASTLE",
    PSL = "PSL",
    BAILLIEU = "BAILLIEU",
    IV = "IV",
    MORRISON = "MORRISON",
    IINVEST = "IINVEST",
    BELL = "BELL",
    FX = "FX",
    OM = "OM"
}